import { Box, Typography } from '@mui/material';

export const YearLegend = () => (
  <Box border="1px solid #3169F6" borderRadius={1.5} p={2} width="100%">
    <Typography fontSize={22}>
      <strong>My Year So Far</strong>
    </Typography>
  </Box>
);
